import { track } from "../track";

interface Params {
  quiz_id?: string;
  name?: string;
  email?: string;
}

export const trackOnBoAppDownload = (params: Params) =>
  track({ event: "on_bo_app_download", ...params });
